module.exports = __webpack_public_path__ + "img/fi-rr-align-right.68407957.svg";